import { render } from "./DeliveryModal.vue?vue&type=template&id=ce09355e&scoped=true"
import script from "./DeliveryModal.vue?vue&type=script&lang=js"
export * from "./DeliveryModal.vue?vue&type=script&lang=js"

import "./DeliveryModal.vue?vue&type=style&index=0&id=ce09355e&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce09355e"]])

export default __exports__